import React from "react";
import {useNavigate} from 'react-router-dom';
import '../styles/components/BlogComponent.css'

const BlogComponent = () => {
    const navigate = useNavigate();

    return (
        <>
            <div className='blog'>
                <h1>المـدونـة</h1>
                <div className='figures'>
                    <div className='figure'>
                        <div className='blog1'></div>
                        <div className='caption'>
                            <h2>انظر إلى عملك من منظور مختلف
                                وجديد..</h2>
                            <p>22/3/2022</p>
                            <a className='button' onClick={() => navigate('/post')}>انقـر للمزيـد</a>
                        </div>
                    </div>
                    <div className='figure'>
                        <div className='blog2'></div>
                        <div className='caption'>
                            <h2>كيف تصبح مليونير؟</h2>
                            <p>22/3/2022</p>
                            <a className='button' onClick={() => navigate('/post')}>انقـر للمزيـد</a>
                        </div>
                    </div>
                    <div className='figure'>
                        <div className='blog3'></div>
                        <div className='caption'>
                            <h2>الدليل النهائي لأفضل ممارسات الأعمال</h2>
                            <p>22/3/2022</p>
                            <a className='button' onClick={() => navigate('/post')}>انقـر للمزيـد</a>
                        </div>
                    </div>
                    <div className='figure blog-page' style={{display: "none"}}>
                        <div className='blog4'></div>
                        <div className='caption'>
                            <h2>أفضل ممارسات العلامات التجارية للشركات الناشئة</h2>
                            <p>22/3/2022</p>
                            <a className='button' onClick={() => navigate('/post')}>انقـر للمزيـد</a>
                        </div>
                    </div>
                    <div className='figure blog-page' style={{display: "none"}}>
                        <div className='blog5'></div>
                        <div className='caption'>
                            <h2>المدرب المعتمد في البوصلة الشخصية</h2>
                            <p>22/3/2022</p>
                            <a className='button' onClick={() => navigate('/post')} >انقـر للمزيـد</a>
                        </div>
                    </div>
                    <div className='figure blog-page' style={{display: "none"}}>
                        <div className='blog6'></div>
                        <div className='caption'>
                            <h2>مهارات التخطيط الشخصي الاحترافي</h2>
                            <p>22/3/2022</p>
                            <a className='button' onClick={() => navigate('/post')}>انقـر للمزيـد</a>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )

}

export default BlogComponent